import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CurrentUserRoleAndLogin } from "../../types/auth.types";

@Component({
  selector: 'app-page-info',
  imports: [],
  templateUrl: './page-info.component.html',
  styleUrl: './page-info.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageInfoComponent {
  resourceName = input.required<string>();
  loginAndRoles = input<CurrentUserRoleAndLogin | null>(null);
}
